import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import getHistorialMovPedidos from '../../../../utils/getHistorialMovPedidos';
import getPedidosPedidos from '../../../../utils/getPedidosPedidos';
import formatMoney from '../../../../utils/formatMoney';
import moment from 'moment';
import _ from 'lodash';




const TabHistorialCancelacion = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Historial de Cancelacion de Pedido</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
            <th>Estado</th>
            <th>Usuario</th>
            <th>Fecha</th>
            <th>Observacion</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstHistorialPedido.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.codUsuarioCancelacionPed}</td>
                <td>{entity.codUsuarioCreaReg}</td>
                <td>{moment(entity.fecCreaReg).format('DD/MM/YYYY')}</td>
                <td>{entity.observacion}</td>
            </tr>
            )
          }



        </tbody>
      </table>
    </div>
  </section>
);

const TabMovimientos = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Movimientos</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
            <th colspan="2">Documento</th>
            <th>fecha</th>
            <th>Moneda</th>
            <th>T.C</th>
            <th>Monto</th>
            <th>Saldo</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstMovimientosPagos.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.cod_tipo_doc}</td>
                <td>{entity.num_doc}</td>
                <td>{moment(entity.fec_docu).format('DD/MM/YYYY')}</td>
                <td>{entity.cod_moneda}</td>
                <td>{entity.val_tipo_cambio}</td>
                <td>{entity.val_monto}</td>
                <td>{entity.saldo}</td>

            </tr>
            )
          }



        </tbody>
      </table>
    </div>
  </section>
);

const TabDocumentos = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Documentos de Ventas</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
              <th colspan="2">Documento</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Moneda</th>
              <th>Monto</th>
              <th>Clase</th>
              <th>Tipo</th>
              <th colspan="2">Referencia</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstDocummentosVenta.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.tipoDoc}</td>
                <td>{entity.noFactu}</td>
                <td>{entity.estado}</td>
                <td>{moment(entity.fecha).format('DD/MM/YYYY')}</td>
                <td>{entity.moneda}</td>
                <td>{formatMoney(entity.valPreDocu)}</td>
                <td>{entity.tiFactura}</td>
                <td>{entity.parcial}</td>
                <td>{entity.docDevol}</td>
                <td>{entity.noDevol}</td>
            </tr>
            )
          }



        </tbody>
      </table>
    </div>
  </section>
);

class TabHistorial extends Component{

  constructor(props){
    super(props);
    this.state={
      lstDocummentosVenta:[],
      lstHistorialPedido:[],
      lstMovimientosPagos:[]
    }
  }

  componentDidMount(){

    this.setState({listaAdicionales:[]});
    this.loadPedidos();

  }


  loadPedidos = () => {
            this.props.loading('block');
            getPedidosPedidos(this.props.pedido.numFichaVtaVeh, [this.props.pedido.numProfVeh]).then((result) => {
                console.log('result',result);
                  let pedido =  _.filter(result, _.property(this.props.pedido.numProfVeh))[0][this.props.pedido.numProfVeh];
                  pedido = pedido.find(entry => entry.numPedidoVeh===this.props.pedido.numPedidoVeh);

                  getHistorialMovPedidos('',pedido.numPedidoVeh,pedido.codProv,pedido.codCia,'123').then(entry => {
                    this.setState({
                      lstDocummentosVenta:entry.data.lstDocummentosVenta,
                      lstHistorialPedido:entry.data.lstHistorialPedido,
                      lstMovimientosPagos:entry.data.lstMovimientosPagos
                    })
                  });
                  this.setState({  pedidos:  pedido});
                  this.props.loading('');
                }).catch((error) => { console.log(error); });
  }



  render(){


    return (
      <div>
          <TabDocumentos
              lstDocummentosVenta={this.state.lstDocummentosVenta }
          />
          <TabMovimientos
              lstMovimientosPagos={this.state.lstMovimientosPagos }
          />
          <TabHistorialCancelacion
              lstHistorialPedido={this.state.lstHistorialPedido }
          />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}


export default withRouter(
  connect(mapStateToProps, {
  })(TabHistorial));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/Historial.js